export default class FormOtherEmployee {
    constructor($el) {
        this.$el = $el;
        this.$control = this.$el.querySelector('[data-select]');
        this.$controlOtherEmployee = this.$el.querySelector('[data-form-control-other-employee ]');

        this.showOtherEmployee = this.showOtherEmployee.bind(this);
        this.hideOtherEmployee = this.hideOtherEmployee.bind(this);
        this.checkControl = this.checkControl.bind(this);

        this.$control.addEventListener('change', this.checkControl);
    }

    showOtherEmployee()
    {
        this.$controlOtherEmployee.classList.remove('d-none');
    }

    hideOtherEmployee()
    {
        this.$controlOtherEmployee.classList.add('d-none');
    }

    checkControl()
    {
        if(this.$control.value === 'other') {
            this.showOtherEmployee();
            return
        }
        this.hideOtherEmployee();
    }
}